import $ from 'jquery'

document.addEventListener('mousemove', (e) => {
  const { clientX, clientY } = e

  const anchor = document.getElementById('logo')
  const ball = document.getElementById('ball')
  const rect = anchor.getBoundingClientRect()

  const anchorX = rect.left + rect.width / 2
  const anchorY = rect.top + rect.height / 2

  const angleDeg = angle(clientX, clientY, anchorX, anchorY)
  ball.style.transform = `rotate(${90 + angleDeg}deg)`
})

const angle = (cx, cy, ex, ey) => {
  const dy = ey - cy
  const dx = ex - cx
  const rad = Math.atan2(dy, dx)
  return (rad * 180) / Math.PI
}

$('.hamburger').on('click', function () {
  $('body').toggleClass('menu-active')

  if (undefined !== window.fp) {
    window.fp.setAllowScrolling(!$('body').hasClass('menu-active'))
    window.fp.setKeyboardScrolling(!$('body').hasClass('menu-active'))
  }
})

$(document).keyup(function (e) {
  if (e.key === 'Escape') {
    $('body').removeClass('menu-active')
  }
})

$.ui.autocomplete.prototype._resizeMenu = function () {
  var ul = this.menu.element
  ul.outerWidth(this.element.outerWidth())
}
